import { render } from "./RuleWaitingListItemModalContent.vue?vue&type=template&id=78f21607"
import script from "./RuleWaitingListItemModalContent.vue?vue&type=script&lang=js"
export * from "./RuleWaitingListItemModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleWaitingListItemModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78f21607"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78f21607', __exports__)) {
    api.reload('78f21607', __exports__)
  }
  
  module.hot.accept("./RuleWaitingListItemModalContent.vue?vue&type=template&id=78f21607", () => {
    api.rerender('78f21607', render)
  })

}


export default __exports__